import { Button, Form, Input, InputNumber, Upload } from "antd";
import { useEffect, useState } from "react";
import styled from "styled-components";
import * as palette from "../../styles/variables";
import { addComplexity } from "../../utils/services/complexity";
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';

export const AddComplexity = ({ cancel, updatedData }) => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const [fileList, setFileList] = useState([]);

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };

  const onAddComplexity = (values) => {
    const formData = new FormData();
    var resp = '';
    if (values.response === undefined || values.response === '') {
      resp = '';
    }
    formData.append('file', fileList[0]);
    formData.append('assemblies', values.assemblies);
    formData.append('complexity_name', values.complexity_name);
    formData.append('examples', values.examples);
    formData.append('no_parts', values.no_parts);
    formData.append('response', resp);
    formData.append('sub_assemblies', values.sub_assemblies);
    setLoading(true);
    addComplexity(
      formData,
      (res) => {
        setLoading(false);
        updatedData(res.data);
        cancel();
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  return (
    <FormContainer>
      <Form
        form={form}
        name="Add assignee"
        colon={false}
        requiredMark={false}
        labelCol={{ span: 24 }}
        onFinish={onAddComplexity}
        autoComplete="off"
      >
        <div className="formItems">
          <Form.Item
            label="Complexity"
            name="complexity_name"
            rules={[
              {
                required: true,
                message: "Please enter the complexity",
              },
            ]}
          >
            <Input
              placeholder="Enter the complexity"
              style={{
                width: "98%",
              }}
            />
          </Form.Item>
          <Form.Item
            label="Examples"
            name="examples"
            rules={[
              {
                required: true,
                message: "Please enter the examples",
              },
            ]}
          >
            <Input
              placeholder="Enter the examples"
              style={{
                width: "98%",
              }}
            />
          </Form.Item>

          <Form.Item
            label="Response"
            name="response"
            rules={[
              {
                required: false,
                message: "Please enter the response",
              },
            ]}
          >
            <Input
              placeholder="Enter the response"
              style={{
                width: "98%",
              }}
            />
          </Form.Item>

          <Form.Item
            label="Assemblies"
            name="assemblies"
            rules={[
              {
                required: true,
                message: "Please enter the assemblies.",
              },
            ]}
          >
            <InputNumber
              placeholder="Enter the assemblies"
              style={{
                width: "98%",
              }}
            />
          </Form.Item>

          <Form.Item
            label="Sub Assemblies"
            name="sub_assemblies"
            rules={[
              {
                required: true,
                message: "Please enter the sub assemblies.",
              },
            ]}
          >
            <InputNumber
              placeholder="Enter the sub assemblies"
              style={{
                width: "98%",
              }}
            />
          </Form.Item>

          <Form.Item
            label="No. Parts"
            name="no_parts"
            rules={[
              {
                required: true,
                message: "Please enter the parts.",
              },
            ]}
          >
            <InputNumber
              placeholder="Enter the parts"
              style={{
                width: "98%",
              }}
            />
          </Form.Item>

          <Form.Item label="Upload" name="file" valuePropName="fileList" multiple={false} getValueFromEvent={normFile} rules={[
            {
              required: true,
              message: "Please upload the image",
            },
          ]}>

            <Upload {...props} listType="picture" multiple={false} maxCount={1} accept="image/*" >
              <Button icon={<UploadOutlined />}>Click to upload</Button>
              {/* <div>
                <PlusOutlined />
                <div
                  style={{
                    marginTop: 8,
                  }}
                >
                  Upload
                </div>
              </div> */}
            </Upload>
          </Form.Item>

        </div>
        <div className="footerBtn">
          <Form.Item>
            <Button className="outlinedBtn" onClick={cancel}>
              Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              className="primaryBtn"
              htmlType="submit"
              style={{ padding: "0px 24px" }}
              disabled={loading}
            >
              Save
            </Button>
          </Form.Item>
        </div>
      </Form>
    </FormContainer>
  );
};

const FormContainer = styled.div`
  padding: 20px 0px;
  .formItems {
    display: grid;
    grid-template-columns: auto auto auto;
    @media only screen and (max-width: 769px) {
      grid-template-columns: auto auto;
    }
  }
  .footerBtn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 20px 30px 0px;
    gap: 20px;
    .ant-form-item {
      margin-bottom: 0px;
    }
  }
`;
